<template>
    <el-dialog
        :visible.sync="Visible"
        v-loading="loading"
        title="请选择要同步的门店"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
        <div style="text-align: center" id="transferDiv">
            <el-transfer
                style="text-align: left; display: inline-block"
                v-model="storeids"
                filterable
                :props="{ key: 'code', label: 'name' }"
                :titles="['门店列表', '已选择']"
                :format="{
                    noChecked: '${total}',
                    hasChecked: '${checked}/${total}'
                }"
                :data="stores"
            ></el-transfer>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="Visible = false">取 消</el-button>
            <el-button type="primary" @click="save">同 步</el-button>
        </span>
    </el-dialog>
</template>
  
<script>
import AjaxHelper from '@/common/js/AjaxHelper'
import pagerBar from '@/views/pager/pagerBar'
import config from '../../common/config'
export default {
    components: {
        pagerBar
    },
    data() {
        return {
            Visible: false,
            loading: false,
            stores: [],
            storeids: [],
            brandID: '',
            moduleConfID: '',
            storeApiUrl: config.BASE_Middle_API + 'BussinessStoreInfo'
        }
    },
    props: {
        Refresh: {
            type: Function,
            required: true
        }
    },
    methods: {
        getStoreData(brandId) {
            const _this = this
            if (brandId === '') {
                this.$notify({
                    title: '提示',
                    message: '请选中品牌后进行操作',
                    type: 'error',
                    position: 'bottom-right'
                })
                return false
            }
            _this.loading = true
            AjaxHelper.get(_this.storeApiUrl + '/GetAllStore', {
                brandId: brandId
            })
                .then(function (response) {
                    if (response.success) {
                        _this.stores = response.result
                        _this.loading = false
                    }
                })
                .catch(function (error) {
                    _this.loading = false
                    _this.Visible = false
                })
        },
        openSelect(currentBrandId, currentmoduleConfID) {
            this.storeids = []
            this.stores = []
            this.Visible = true
            this.brandID = currentBrandId
            this.moduleConfID = currentmoduleConfID
            this.getStoreData(currentBrandId)
        },
        save() {
            const _this = this
            console.log(_this.storeids)
            _this.loading = true
            if (_this.storeids.length == 0) {
                _this.$message({
                    type: 'error',
                    message: '请选择要同步的门店'
                })
                _this.loading = false
                return
            }
            var input = {
                storeIds: _this.storeids,
                brandId: _this.brandID,
                moduleConfId: _this.moduleConfID
            }
            AjaxHelper.post(_this.storeApiUrl + '/QuickSync', input)
                .then((r) => {
                    if (r.success) {
                        _this.$notify({
                            title: '成功',
                            message: '同步成功',
                            type: 'success',
                            position: 'bottom-right'
                        })
                        _this.Refresh()
                    }
                    _this.Visible = false
                    _this.loading = false
                })
                .catch((e) => {
                    _this.loading = false
                    _this.Visible = false
                })
        }
    }
}
</script>
  
<style>
/* #transferDiv .el-transfer-panel {
  width: 300px;
  height: 500px;
}
#transferDiv .el-transfer-panel__list.is-filterable {
  height: 400px;
} */
</style>
